{
  "textSize": "Text Size",
  "smaller": "smaller",
  "larger": "larger",
  "lineHeight": "Line Height",
  "name": "Name",
  "less": "less",
  "more": "more",
  "done": "Done",
  "defaultContrast": "Default Contrast",
  "darkMode": "Dark Mode",
  "lightMode": "Light Mode",
  "viewerTheme": "Viewer Theme",
  "themeDesc": "Customize the way your log viewer looks. Only you will see this.",
  "mutedDebug": "Muted <span class=\"ll-lvl base-lvl-default\">DEBUG</span> statements",
  "logLevelDebug": " Checking this will show lines with log level of <span class=\"ll-lvl base-lvl-default\">DEBUG</span> in a lighter shade of color.",
  "showUTC": "Show <span class=\"line-token\">%time</span> as UTC",
  "utcDesc": "Timestamps will be shown in UTC and timeframe searches will be done relative to UTC instead of local time.",
  "onlyGM": "This option is only available for GM members.",
  "userProfile": "User Profile",
  "authProviderName": "Currently using the name provided by your OAuth provider",
  "personalAuthToken": {
    "menuTitle": "Access Tokens",
    "title": "Personal Access Tokens",
    "description": "Mezmo personal access keys are user-scoped API tokens you generate for your own use to call Mezmo APIs.  The are limited to a similar level of access that your user account has.",
    "keyTitle": "Access Token",
    "generate": "Generate",
    "modalTitle": "Generate Personal Access Token",
    "modalFormLabel": "Personal Access Token Name",
    "assumeRoleLabel": "Assume the same permissions as your current user's role",
    "editModalTitle": "Edit Personal Access Token",
    "entity": "personal access token",
    "permissionsLocked": "Permissions cannot be changed after a personal access token is created. To change access, create a new token.",
    "permissionMessage": "You do not have permission to create personal access tokens",
    "noAccess": "You do not have permission to view personal access tokens. Contact an account admin or owner to request access."
  },
  "slack": {
    "prefsTab": "Slack",
    "title": "Linked Slack Users",
    "description": "Linking a Slack user to your Mezmo user tells Mezmo the two are the same person. When that Slack user clicks Approve or Deny on a Slack approval notice, the decision is recorded as yours and checked against your access in the account it concerns. The link holds in every account you are a member of. Link only your own Slack users, one per workspace.",
    "table": {
      "slackUser": "Slack User",
      "workspace": "Workspace",
      "linked": "Linked"
    },
    "emptyTitle": "No Linked Slack Users",
    "emptyMessage": "Click Approve or Deny on a Slack approval notice to get a link prompt. The link it sends you opens here.",
    "unlink": "Unlink",
    "unlinkModalTitle": "Unlink Slack user {{user}}?",
    "unlinkModalBody": "The Slack user can no longer approve or deny requests as you, in any account. The next time they click Approve or Deny they are asked to link again.",
    "unlinked": "Slack user unlinked.",
    "unlinkFailed": "An error occurred while trying to unlink the Slack user.",
    "fetchFailed": "An error occurred while trying to fetch your Slack links.",
    "link": {
      "question": "Link Slack user {{user}} in workspace {{workspace}} to your Mezmo user?",
      "signedInAs": "Signed in as {{email}}",
      "help": "Once linked, this Slack user can approve and deny requests from Slack as you, in any account you are a member of. Only link a Slack user that is your own. If you did not click Approve or Deny in Slack yourself, cancel.",
      "expires": "This link can be used until {{time}}.",
      "confirm": "Link Slack User",
      "retry": "Try Again",
      "linkedMessage": "{{user}} in {{workspace}} can now approve and deny requests from Slack as you.",
      "missingTitle": "Link Not Found",
      "missingMessage": "Linking starts from the link a Slack approval notice sends you. Click Approve or Deny in Slack while signed in to Mezmo to get a new one.",
      "expiredTitle": "Link Used or Expired",
      "expiredMessage": "This link has been used or has expired. Click Approve or Deny in Slack again to get a new one.",
      "conflictTitle": "Slack User Already Linked",
      "conflictMessage": "This Slack user is already linked to another Mezmo user. They must unlink it before it can be linked to you.",
      "teamLinkedTitle": "Workspace Already Linked",
      "teamLinkedMessage": "Another Slack user in this workspace is already linked to you. Unlink it first, then click Approve or Deny in Slack again to get a new link.",
      "previewFailedTitle": "Could Not Read Link",
      "previewFailedMessage": "An error occurred while trying to read this link.",
      "linkFailedTitle": "Link Failed",
      "linkFailedMessage": "An error occurred while trying to link the Slack user. Try again, or click Approve or Deny in Slack to get a new link."
    }
  }
}
